import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuth } from "../../contexts/AuthContext";
import HelpdeskMainMenu from "./HelpdeskMainMenu";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function HelpdeskStart(props) {
  const { currentUser } = useAuth();

  const tooltip = (
    <Tooltip id="tooltip" className="custom-tooltip">
      <div className="d-flex justify-content-top m-0 p-0" style={{ maxWidth: "96px" }}>
        <div className="d-flex justify-content-middle m-0">
          <span className="material-icons pt-1">help</span>
        </div>
        <div className="m-0 narrow-tooltip lh-1 text-start">
          <span
            style={{
              fontSize: "9px",
              fontWeight: "450",
            }}
          >
            CENTRAL DE
          </span>
          <br />
          <span
            style={{
              fontSize: "18px",
            }}
          >
            <strong>AJUDA</strong>
          </span>
        </div>
      </div>
    </Tooltip>
  );

  if (!currentUser) return <></>;
  else
    return (
      <>
        <>
          <OverlayTrigger placement="left" overlay={tooltip} delayShow={300} delayHide={150} style={{ zIndex: "10000" }}>
            <button
              id="btnLocucao"
              className="btn btn-light float-end me-2 custom-tooltip"
              style={{
                position: "fixed",
                top: "calc(50% + 68px)",
                right: "2px",
                minWidth: "40px",
                maxWidth: "40px",
                minHeight: "40px",
                maxHeight: "40px",
                color: "rgba(255, 255, 255, 0.88)",
                borderRadius: "8px",
                paddingTop: "5px",
                paddingBottom: "1px",
                paddingLeft: "4px",
                paddingRight: "4px",
                backgroundImage: "linear-gradient(to right, #2c7ce7 0%, #2e7fea 100%)",
                border: "none",
                zIndex: "10000",
              }}
              // onClick={activateLocaucao}
              // data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-custom-class="custom-tooltip"
              data-bs-title="Central de Ajuda"
              // data-bs-toggle="offcanvas"
              // href="#offcanvasCookiesPolitics"
              // role="button"
              // aria-controls="offcanvasCookiesPolitics"

              // className="text-decoration-none"
              data-bs-toggle="offcanvas"
              href="#offcanvasHelpdeskMainMenu"
              // role="button"
              aria-controls="offcanvasHelpdeskMainMenu"
            >
              <span className="material-icons">help</span>
            </button>
          </OverlayTrigger>
        </>
        <HelpdeskMainMenu />
      </>
    );
}
